module.exports = __webpack_public_path__ + "static/media/3 09 Tulleord Vor er riktig-norming.2f5c26db.mp3";